<template>
  <div class="main">
    <div>
      <h1>部门信息设置</h1>
      <el-form label-position="top" label-width="80px" ref="ruleForm" status-icon>

        <el-form-item label="当前部门">
          <el-input :disabled="true" placeholder style="width: 570px" v-model="currentTeamName"></el-input>
        </el-form-item>

        <el-form-item label="当前部门成员">
          <el-tag :key="userName" class="username" type="success" v-for="userName in currentTeamUsers">{{ userName }}
          </el-tag>
        </el-form-item>


        <el-form-item label="当前部门分享码">
          <el-form-item >
            <el-input :disabled="true" placeholder style="width: 450px" v-model="currentTeamKey"></el-input>

            <el-button @click="resetTeamKey" size="medium" style="width: 100px;margin-left:10px" type="primary">重新生成</el-button>

          </el-form-item>

        </el-form-item>

        <el-form-item label="当前部门woa群聊机器人token">
          <el-input  placeholder style="width: 570px"
                    v-model="teamWoaToken"></el-input>
          <br>
          <el-alert
              @close="modifyWoaTokenInit"
              show-icon
              title="请勿随意改动，否在将无法正常推送消息到woa"
              type="warning">
          </el-alert>
        </el-form-item>

        <el-form-item class="register-btn">
          <el-button @click="updateTeam" size="medium" style="width: 180px" type="primary">确认</el-button>
          <el-button @click="showDialogForAdd" size="medium" style="width: 180px" type="info">加入新部门</el-button>
          <el-button @click="showDialogForCreate" size="medium" style="width: 180px" type="info">创建新部门</el-button>

        </el-form-item>
      </el-form>
    </div>


    <el-dialog :visible.sync="formVisibleForCreate" title="创建新部门">
      <el-form>
        <el-form-item :label-width="formLabelWidth" label="填入部门名称">
          <el-input autocomplete="off" v-model="createTeamName"></el-input>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" label="Woa token">
          <el-input autocomplete="off" v-model="newTeamWoaToken"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="formVisibleForCreate = false">取 消</el-button>
        <el-button @click="createNewTeam" type="primary">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="formVisibleForAdd" title="加入新部门">
      <el-form>
        <el-form-item :label-width="formLabelWidth" label="填入部门邀请码">
          <el-input autocomplete="off" v-model="addTeamKey"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="formVisibleForAdd = false">取 消</el-button>
        <el-button @click="addNewTeam" type="primary">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>


<script>

import {Apis} from "@/api";

export default {
  data() {
    return {
      formLabelWidth: '120px',
      formVisibleForAdd: false,
      formVisibleForCreate: false,


      currentTeamName: "",
      currentTeamID: "",
      currentTeamKey: "",
      currentTeamUsers: [],

      addTeamKey: "",
      createTeamName: "",
      newTeamWoaToken: "",

      teamWoaToken: "",

      modifyWoaTokenVisible: true,

    }
  },
  methods: {
    modifyWoaTokenInit() {
      this.modifyWoaTokenVisible = false
    },
    resetData() {
      this.addTeamKey = ""
      this.createTeamName = ""
      this.newTeamWoaToken = ""

    },
    showDialogForAdd() {
      this.formVisibleForAdd = true
    },
    showDialogForCreate() {
      this.formVisibleForCreate = true
    },

    async initTeamInfo() {
      const response = await Apis.Team.getTeam()
      if (response.data === null) {
        this.currentTeamUsers = []
        this.currentTeamName = ""
        this.currentTeamKey = ""
        this.teamWoaToken = ""
      } else {
        this.currentTeamUsers = response.data["teamUsers"]
        this.currentTeamName = response.data["teamName"]
        this.currentTeamKey = response.data["teamKey"]
        this.teamWoaToken = response.data["teamWoaToken"]
      }
      this.resetData()
    },

    async updateTeam() {
      const response = await Apis.Team.updateTeam(this.teamWoaToken)
      // console.log("updateTeam", response)
      if (response.errno === 0) {
        await this.$message.success("woaToken 修改成功")

        //重新让woaToken的输入框变得不可输入
        this.modifyWoaTokenVisible = true
      }
    },

    async resetTeamKey() {
      const response = await Apis.Team.resetTeamKey()

      if (response.data === null) {
        this.currentTeamKey = "key生成失败"
      } else {
        this.currentTeamKey = response.data["key"]
      }
    },

    async createNewTeam() {
      if (this.createTeamName === "") {
        this.$message.error("请填入部门名称")
        return
      }

      if (this.createTeamName.length > 20) {
        this.$message.error("部门名称最多20个字符")
        return
      }

      if (this.teamWoaToken.length !== 32) {
        this.$message.error("woa群聊机器人的token应该是32位数字或字母")
        return
      }

      const response = await Apis.Team.createTeam(this.createTeamName, this.newTeamWoaToken)
      // console.log("create new team", response)
      if (response.errno === 0) {
        const txt = "成功加入" + response.data.teamName
        this.$message.success(txt)
      }

      this.resetData()
      this.formVisibleForCreate = false
      await this.$router.go(0)//强制刷新当前页面

    },

    async addNewTeam() {
      if (this.addTeamKey === "") {
        this.$message.error("请填入邀请码")
        return
      }

      const response = await Apis.Team.joinTeam(this.addTeamKey)
      // console.log("addTeam", response)
      if (response.errno === 0) {
        const txt = "成功加入" + response.data["teamName"]
        this.$message.success(txt)
      }

      this.resetData()
      this.formVisibleForAdd = false
      await this.$router.go(0)//强制刷新当前页面

    },


  },
  created() {
    this.initTeamInfo()
  }
}
</script>

<style scoped>
h1 {
  text-align: center;
}

.main {
  display: flex;
  justify-content: center;
}

.register-btn {
  text-align: center;
}


.username {
  margin: 5px;
}
</style>
